import React from 'react'
import {IdProvider} from 'react-use-id-hook'

const wrapWithId = context => {
	context.app = <IdProvider>{context.app}</IdProvider>
}

export default wrapWithId
